import React from 'react';
import DocumentTitle from 'react-document-title';
import UA from '../../utils/ua';
import AXIOS from '../../api/axios';
import clientApi from '../../api/client';
import BASE_CONFIG from '../../api/env';
import './style.less';
const SHARE_KEY = '210_H5HomeWorkShare'; // 分享内链配置key
const MAX = 10;
export default class ReadWorks extends React.PureComponent{
    state = {
        list: [],
    }
    num = 1;
    loadMoreStatus = 1;
    starsArr = new Array(3).fill(0);
    componentDidMount() {
        AXIOS.getShareConfig({
            params: { key: SHARE_KEY }
        }).then((res = {}) => {
            const { data = {}} = res;
            this.shareParams = data[SHARE_KEY];
        });
        this.getData(this.num++);
        window.addEventListener('scroll', this.onScroll);
    }
    onScroll = () => {
        if (this.loadMoreStatus !== 2) { return }
        const { scrollHeight, clientHeight } = document.documentElement;
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop + clientHeight >= scrollHeight - 20) {
            this.loadMoreStatus = 1;
            this.getData(this.num++);
        }
    }
    getData = (num) => {
        AXIOS.getReadWorksList({
            data: { num, row: MAX }
        }).then((res) => {
            const { list } = this.state;
            const { data = [] } = res;
            if (data.length >= MAX) {
                this.loadMoreStatus = 2;
            } else {
                this.loadMoreStatus = 0;
            }
            if (num === 1 && data.length === 0) {
                return this.setState({ list: null });
            }
            this.setState({ list: [...list.concat(data)] });
        })
    }
    toShare = (stuId, courseSectionId, classSchId, star, courseDetailId, courseId, e) => {
        e.stopPropagation();
        AXIOS.acClientBp({
            data: {
                project: '客户端3.12.0',
                type: 1,
                pageName: '跟读作品列表',
                clickName: '分享',
                userId: stuId,
                courseId: courseId,
                courseDetailId: courseDetailId,
                kind: star,
            }
        })
        clientApi.shareNew({
            ...this.shareParams,
            type: 2,
            shareByUrl: true,
            shareUrl: `${BASE_CONFIG.wxBaseUrl}/h5/share-read?stuId=${stuId}&classSchId=${classSchId}&courseSectionId=${courseSectionId}&star=${star}&courseDetailId=${courseDetailId}`,
            resource: 'homework'
        })
    }
    goDetail = (stuId, courseSectionId, classSchId, star, courseDetailId, courseId) => {
        const { wxBaseUrl } = BASE_CONFIG;
        AXIOS.acClientBp({
            data: {
                project: '客户端3.12.0',
                type: 1,
                pageName: '跟读作品列表',
                clickName: '作品',
                userId: stuId,
                courseId: courseId,
                courseDetailId: courseDetailId,
                kind: star,
            }
        })
        window.location.href = `${wxBaseUrl}/h5/share-read?stuId=${stuId}&classSchId=${classSchId}&courseSectionId=${courseSectionId}&star=${star}&courseDetailId=${courseDetailId}`;
    }
    render() {
        const { loadMoreStatus, list } = this.state;
        return <DocumentTitle title="跟读作品">
            <div className="ReadWorks">
                {list && list.length > 0 ? <ul className="works-list">
                    {
                        list.map((item, index) => (
                        <li key={index} className="works-model" onClick={this.goDetail.bind(this, item.stuId, item.courseSectionId, item.classSchId || 0, item.starsCnt, item.courseDetailId, item.courseId)}>
                            <div className="works-content">
                                <div className="content-img" style={item.cover ? {'background':`url(${item.cover}) center center / cover no-repeat`} : {}}></div>
                                <div className="content-info">
                                    <p className="content-title">{item.enTitle}</p>
                                    <p className="content-desc">{item.cnTitle}</p>
                                </div>
                            </div>
                            <div className="works-status">
                                <div className="works-stars-box">
                                    {
                                        this.starsArr.map((_, index) => (
                                            <span
                                                key={index}
                                                className={`works-stars${item.starsCnt > index ? ' active' : ''}`}
                                            />
                                        ))
                                    }
                                </div>
                                <div className="works-operate">
                                    <button className="works-operate-btn" onClick={(e) => e.stopPropagation()}>{item.likeCount}</button>
                                    {!UA.winClient && <button className="works-operate-btn" onClick={this.toShare.bind(this, item.stuId, item.courseSectionId, item.classSchId || 0, item.starsCnt, item.courseDetailId, item.courseId)} >分享</button>}
                                </div>
                            </div>
                        </li>
                        ))
                    }
                    
                </ul> : null}
                {loadMoreStatus === 0 && <p className="no-more">没有更多了 ~</p>}
                {list === null && <div className="empty-box">
                    <div className="empty-img" />
                    <p>这里空空如也~</p>
                </div>}
            </div>
        </DocumentTitle>
    }
}


// WEBPACK FOOTER //
// ./src/components/readWorks/index.js